import { AuthService } from 'src/app/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getProfile() {
    return this.http.get<any>(`${environment.apiUrl}/admin/user/profile`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  updateDetails(firstName: string, lastName: string, avatar: any) {
    const formData = new FormData();
    formData.append('first_name', firstName);
    formData.append('last_name', lastName);

    if (avatar) {
      formData.append('avatar', avatar);
    }

    return this.http.post<any>(`${environment.apiUrl}/admin/user/profile`, formData)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  updatePassword(currentPassword: string, newPassword: string) {
    return this.http.post<any>(`${environment.apiUrl}/admin/user/password`, {
      password: currentPassword,
      new_password: newPassword
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  list(pageNumber: number = 1, searchValue: string = '', dateFrom: string = '', dateTo: string = '', suspended: string = '', searchRole:string = '') {
    /*
    let params = 'page=' + pageNumber + '&search=' + searchValue;
    if (dateFrom !== '' && dateTo !== '') {
      params += '&from=' + dateFrom + '&to=' + dateTo;
    }

    if (suspended !== '') {
      params += '&suspended=' + suspended
    }
    return this.http.get<any>(`${environment.apiUrl}/admin/users/list?${params}`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
    */

    return this.http.post<any>(`${environment.apiUrl}/admin/users/list`, {
      page: pageNumber,
      search: searchValue,
      from: dateFrom,
      to: dateTo,
      suspended: suspended,
      role: searchRole
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  adminList(pageNumber: number = 1, searchValue: string = '', organisation: number = 0) {
    /*
    const params = 'page=' + pageNumber + '&search=' + searchValue + '&organisation=' + organisation;
    return this.http.get<any>(`${environment.apiUrl}/admin/users/list?${params}`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
    */

    return this.http.post<any>(`${environment.apiUrl}/admin/users/list`, {
      page: pageNumber,
      search: searchValue,
      organisation: organisation,
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));

  }

  adminUpdateUserRole(userId: number, role: string, organisationId: number = 0) {
    const formData: any = {};

    formData.id = userId;
    formData.role = role;

    if (organisationId !== 0) {
      formData.organisation_id = organisationId;
    }

    return this.http.post<any>(`${environment.apiUrl}/admin/users/role`, formData)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  adminUpdateUserStatus(userId: number, status: number) {
    const formData: any = {};

    formData.id = userId;
    formData.status = status;

    return this.http.post<any>(`${environment.apiUrl}/admin/users/status`, formData)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  getUserStatistics() {
    return this.http.get<any>(`${environment.apiUrl}/admin/user/completed_tasks`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  updateUserStatistics(moduleId: number, taskType: string) {
    return this.http.post<any>(`${environment.apiUrl}/admin/user/completed_tasks`, {
      module_id: moduleId,
      task_type: taskType
    })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  getResources(type: string) {
    return this.http.get<any>(`${environment.apiUrl}/admin/resources/${type}`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  getResource(id: number) {
    return this.http.get<any>(`${environment.apiUrl}/admin/resources/get/${id}`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  saveResource(details: FormData) {
    return this.http.post<any>(`${environment.apiUrl}/admin/resources`, details)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  deleteResource(id: number) {
    return this.http.delete<any>(`${environment.apiUrl}/admin/resources/${id}`)
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  sendNotification(label: string, notificationText: string) {
    return this.http.post<any>(`${environment.apiUrl}/admin/push-notifications`, {
        label: `${label}`,
        text: notificationText
      })
      .pipe(map(response => {
        this.authService.setNewToken(response.token);
        this.authService.setUserData(response.user);
        return response;
      }));
  }

  challengeReportList(pageNumber: number = 1, organisation: string = '', name_or_email: string = '', voucher: string = '', dateFrom: string = '', dateTo: string = '') {

    return this.http.post<any>(`${environment.apiUrl}/admin/challenge_reports/list`, {
      page: pageNumber,
      organisation: organisation,
      name_or_email: name_or_email,
      voucher: voucher,
      from: dateFrom,
      to: dateTo,
    })
    .pipe(map(response => {
      this.authService.setNewToken(response.token);
      this.authService.setUserData(response.user);
      return response;
    }));
  }

}
